export const formatCurrency = (value, showCents = false) => {
    if (value === undefined || value === null) return '$0';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: showCents ? 2 : 0,
        maximumFractionDigits: showCents ? 2 : 0
    });
    return formatter.format(value);
};

export const formatDuration = (durationString) => {
    if (!durationString) return 'N/A';
  
    // Assuming durationString is like "7:26:00" or similar from timedelta
    const parts = durationString.split(':');
    if (parts.length < 2) return durationString; // Or some other fallback

    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);

    if (isNaN(hours) || isNaN(minutes)) return 'N/A';

    let result = '';
    if (hours > 0) {
        result += `${hours}h `;
    }
    if (minutes > 0 || hours === 0) {
        result += `${minutes}m`;
    }

    return result.trim() || '0m';
};

export const formatHours = (decimalHours) => {
    if (decimalHours === undefined || decimalHours === null || isNaN(decimalHours)) return '0h';

    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);

    // Handle edge case where rounding results in 60 minutes
    if (minutes === 60) {
        return `${hours + 1}h`;
    }

    let result = '';
    if (hours > 0) {
        result += `${hours}h`;
    }
    if (minutes > 0) {
        if (hours > 0) result += ' ';
        result += `${minutes}m`;
    }

    return result || '0h';
};

/**
 * Format a datetime string to local date and time
 * Handles timezone conversion from UTC to local time
 */
export const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

/**
 * Format a datetime string to just local time
 */
export const formatTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

/**
 * Format a datetime string to just local date
 */
export const formatDate = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return date.toLocaleDateString();
}; 